import http from '@utils/http'
/**
 * 获取设备列表
 */
export function getDeviceList(data): Promise<any> {
    return http.post('/sim/deviceInfoList', data || {})
}
/* 
* 编辑设备名称
*/
export function editSimName(data): Promise<any> {
    return http.post('/sim/editSim', data || {})
}

